import React from 'react'
import { Dispatch } from 'redux'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  makeStyles
} from '@material-ui/core'
import TextArea from '../atoms/TextArea'
import axios from 'axios'
import { connect } from 'react-redux'
import { setDialog } from '../../store/actions/dialog'
import { User } from '../../types/User'

const useStyles = makeStyles(theme => ({
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const UserNoteModal: React.FC<
  {
    kaiinNo: string
    isOpen: boolean
    closeHandler: () => void
  } & ReturnType<typeof mapDispatchToProps>
> = ({ setDialog, kaiinNo, isOpen, closeHandler }) => {
  const classes = useStyles()
  const handleClose = React.useCallback(() => {
    closeHandler()
  }, [closeHandler])
  const [note, setNote] = React.useState('')
  const fetch = React.useCallback(async () => {
    const { data } = await axios.get<User>(`/users/kaiin/${kaiinNo}`)
    setNote(data.note)
  }, [kaiinNo])

  React.useEffect(() => {
    fetch()
  }, [fetch])

  const onSave = React.useCallback(async () => {
    try {
      await axios.put(`/users/kaiin/${kaiinNo}`, { note })
      closeHandler()
    } catch (err) {}
  }, [kaiinNo, setDialog, note])

  return (
    <Dialog
      maxWidth="lg"
      open={isOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      closeAfterTransition
    >
      <DialogTitle>メモ</DialogTitle>
      <DialogContent style={{ width: 600 }}>
        <TextArea
          value={note}
          rows={10}
          inputHandler={input => {
            setNote(input)
          }}
          fullWidth
          variant="outlined"
          placeholder="メモを入力"
        />
      </DialogContent>
      <DialogActions className={classes.flexCenter}>
        <Button variant="contained" onClick={handleClose} color="primary">
          キャンセル
        </Button>
        <Button variant="contained" onClick={onSave} color="primary">
          登録
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setDialog: (
      title: string,
      content: string,
      okHandler: () => void,
      ngHandler: () => void,
      noCancel?: boolean
    ) => dispatch(setDialog(title, content, okHandler, ngHandler, noCancel || false))
  }
}

export default connect(null, mapDispatchToProps)(UserNoteModal)
